import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router);
import CRs from "../controller/route/index";
import CPs from "../controller/public/index"
let CP = new CPs();
let CR = new CRs();

import Course from './course'
import Exam from './exam'
import My from './my'
import Article from './article'
import Sign from './sign'
import Vote from './vote'
import webview from "./webview";
import teacherlist from "./teacherlist";
import questionnaire from "./questionnaire";
import bargain from "./bargain";
import group from "./group";
import deposit from "./deposit";
import clockIn from "./clockIn";
import games from "./games";

const R = new Router({
    mode: 'history',
    routes: [
        {
            path:'/',
            component: (resolve) => require(['@/components/index/Index'],resolve),
            meta: {
                title:'',
            }
        },
        {
            path:'/index/search',
            component: (resolve) => require(['@/components/index/Search'],resolve),
            meta: {
                title:'',
            }
        },
        ...Course,
        ...Exam,
        ...My,
        ...Article,
        ...Sign,
        ...Vote,
        ...webview,
        ...teacherlist,
        ...questionnaire,
        ...bargain,
        ...group,
        ...deposit,
        ...clockIn,
        ...games,
    ]
});


R.beforeEach((to, from, next) => {

    if(to.meta.multiple && from.fullPath != '/' && from.meta.exclude != 'pageBack' && from.name != 'weChartSign'){
        CR.setPageBack(from.fullPath,to.meta.title);
    }

    if(from.query.shareid){
        if (!to.query.shareid) {
            if(to.meta.share && to.meta.share == true){
                let query = to.query
                query.shareid = from.query.shareid
                next({
                    path: to.path,
                    query: query
                })
            }
        }
    }
    next()
})

R.afterEach((to,from,next)=>{
    if(to.name == 'webSign' || (to.name == 'weChartSign' && to.query.code == null)){
        if(from.meta.exclude != 'sign'){
            CR.setCallBack(from.fullPath);
        }
    }
    if(to.name == 'binding'){
        if(from.meta.exclude != 'binding'){
            CR.setCallBack(from.fullPath);
        }
    }
});
export default R;



// WEBPACK FOOTER //
// ./src/router/index.js